import { route, tag, type PageTour } from '../pageTour';

// The page has two views: a camera list on load, and a player once a camera is picked. Steps
// whose target isn't on screen are dropped, so each view gets its own part of this tour.
export const recordingsTour: PageTour = {
  id: 'page-recordings',
  version: 2,
  title: 'Recordings',
  summary: 'Find and play back recorded video by camera and time.',
  match: route('/recordings'),
  steps: [
    {
      target: tag('recordings-cameras'),
      title: 'Pick a camera',
      description: "Click a camera to watch what it recorded. Use the filters on the left to search by name or group. Once a camera is open, choose Tour this page again for the player and timeline.",
      side: 'top',
    },
    {
      target: tag('recordings-back'),
      title: 'Back to cameras',
      description: 'Return to the full camera list.',
      side: 'bottom',
    },
    {
      target: tag('recordings-days'),
      title: 'Days with footage',
      description: 'Each day this camera has recordings for. Click one to load it.',
      side: 'bottom',
    },
    {
      target: tag('playback-camera-panel'),
      title: 'Switch camera',
      description: 'Click another camera to see its recordings for the same day.',
      side: 'right',
    },
    {
      target: tag('recordings-player'),
      title: 'Player',
      description: 'The recorded video plays here. Click the picture to play or pause.',
      side: 'bottom',
    },
    {
      target: tag('playback-timeline'),
      title: 'Timeline',
      description: 'Pick a time range, then play, skip or change speed. Drag across the timeline to select a stretch to play or download.',
      side: 'top',
    },
    {
      target: tag('recordings-segments'),
      title: 'Recorded clips',
      description: 'Every clip in the chosen time range. Click one to play it, or download it if you have access.',
      side: 'left',
    },
  ],
};
